import React from 'react';
import style from "./Warning.scss";

export const Warning = ({text}) => {
  return (
    <div className={style.container}>
      <p className={style.text}>Importante: {text}</p>
    </div>
  )
}
